import * as React from "react";

const BackendStagingBanner: React.FC = () => {
  return (
    <div className="bg-amber-soft/70 header-h6 absolute top-0 left-0 z-max w-full p-2.5 text-center font-bold pointer-events-none">
      🚧 Using Backend Staging 🚧
    </div>
  );
};

export default BackendStagingBanner;
